<ng-template #shippingInfo>
  <p class="ff-bold">{{ 'checkoutAddress.understandingShippingPreferences' | cxTranslate }}</p>

  <p>
    <span class="ff-medium">{{ 'checkoutAddress.shipWhenAvailable' | cxTranslate }}</span
    >: {{ 'checkoutAddress.shipWhenAvailableDescription' | cxTranslate }}
  </p>

  <p>
    <span class="ff-medium">{{ 'checkoutAddress.shipLineItemComplete' | cxTranslate }}</span
    >: {{ 'checkoutAddress.shipLineItemCompleteDescription' | cxTranslate }}
  </p>

  <p>
    <span class="ff-medium">{{ 'checkoutAddress.shipCompleteOrder' | cxTranslate }}</span
    >: {{ 'checkoutAddress.shipCompleteOrderDescription' | cxTranslate }}
  </p>
</ng-template>

<ng-container
  *ngIf="{
    cart: cart$ | async,
    preferences: preferences$ | async,
  } as content"
>
  <div class="simple-card m-t-20">
    <h2 class="cx-checkout-title d-none d-lg-block d-xl-block">
      {{ 'checkoutAddress.shippingAddress' | cxTranslate }}
    </h2>

    <form class="m-t-20" [formGroup]="form" (submit)="next()">
      <div class="form-group">
        <label>
          <span class="label-content d-flex h-start v-center">
            {{ 'checkoutAddress.shippingPreferences' | cxTranslate }}

            <tooltip-icon [template]="shippingInfo" [tooltipStyleClass]="'tooltip-shippingInfo'"></tooltip-icon>
          </span>

          <select class="form-control" formControlName="shippingPreference">
            <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
            <option *ngFor="let item of content.preferences" [attr.aria-label]="item.label" value="{{ item.code }}">
              {{ item.label }}
            </option>
          </select>

          <cx-form-errors [control]="form.get('shippingPreference')"></cx-form-errors>
        </label>
      </div>

      <button type="submit" class="d-none" [attr.aria-hidden]="true">{{ 'generic.submit' | cxTranslate }}</button>
    </form>

    <p class="m-t-12">
      {{ 'checkoutAddress.selectYourDeliveryAddress' | cxTranslate }}
    </p>

    <div class="m-t-12">
      @if (content.cart?.deliveryAddress) {
        <address-card [card]="{ address: content.cart?.deliveryAddress!, card: {} }"></address-card>
      } @else {
        <p class="text-danger">{{ 'checkoutAddress.noAddressSelected' | cxTranslate }}</p>
      }

      <button class="btn-link ff-medium m-t-12" (click)="openAddressesModal()">
        {{ 'checkoutAddress.changeShippingAddress' | cxTranslate }}
      </button>
    </div>

    <div class="row cx-checkout-btns justify-content-between p-0">
      <div class="col-12 col-lg-4 m-t-20">
        <button class="cx-btn btn btn-block btn-outline-primary w-100" (click)="back()">{{ 'common.back' | cxTranslate }}</button>
      </div>

      <div class="col-12 col-lg-4 m-t-20">
        <button class="cx-btn btn btn-block btn-primary w-100" (click)="confirmAddress()">
          {{ 'common.continue' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
